// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- DS */

:root {
    --ds-toast-bg-color: var(--ds-color-grey-70);
    --ds-toast-label-color: var(--ds-font-color-accent);
    --ds-toast-message-color: var(--ds-color-grey-20);
    --ds-toast-message-only-color: var(--ds-color-grey-20);
    --ds-toast-close-button-color: var(--ds-color-grey-20);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
